/* Steel Pack quick add: any element with data-sp-add="<variant id>" adds that variant to the cart
   and refreshes Horizon's cart drawer, bubble and items through the theme's own CartAddEvent. */
import { CartAddEvent } from '@theme/events';

if (!window.__spQuickAdd) {
  window.__spQuickAdd = true;

  document.addEventListener('click', async (event) => {
    const btn = event.target instanceof Element ? event.target.closest('[data-sp-add]') : null;
    if (!btn) return;
    event.preventDefault();
    const id = Number(btn.getAttribute('data-sp-add'));
    if (!id || btn.getAttribute('aria-busy') === 'true') return;

    const label = btn.textContent;
    btn.setAttribute('aria-busy', 'true');
    btn.textContent = 'Adding…';

    const sections = new Set();
    document.querySelectorAll('cart-items-component').forEach((el) => {
      if (el instanceof HTMLElement && el.dataset.sectionId) sections.add(el.dataset.sectionId);
    });

    try {
      const res = await fetch((window.Shopify?.routes?.root || '/') + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          items: [{ id, quantity: 1 }],
          sections: Array.from(sections).join(','),
          sections_url: window.location.pathname,
        }),
      });
      const data = await res.json();
      if (!res.ok || data.status) throw new Error(data.description || data.message || 'Could not add');

      // Read the new item count from the re-rendered drawer HTML (no second request).
      let itemCount;
      try {
        const html = Object.values(data.sections || {})[0];
        if (html) {
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const n = doc.querySelector('[ref="cartItemCount"]')?.textContent;
          if (n) itemCount = parseInt(n, 10);
        }
      } catch (e) {}

      document.dispatchEvent(
        new CartAddEvent({}, 'sp-quick-add', {
          source: 'sp-quick-add',
          itemCount,
          variantId: String(id),
          sections: data.sections,
        })
      );
      btn.textContent = 'Added ✓';
      setTimeout(() => {
        if (btn.isConnected) btn.textContent = label;
      }, 1800);
    } catch (err) {
      btn.textContent = 'Sold out';
      console.error(err);
    } finally {
      btn.removeAttribute('aria-busy');
    }
  });
}
